/**
 * Theme. Dark is the default — this app gets used at night, and that is what
 * the owner asked for. The toggle in Settings persists an explicit choice.
 */

import { readLocal, writeLocal } from "./store.ts";

export type Theme = "dark" | "light";

export function currentTheme(): Theme {
	return document.documentElement.dataset.theme === "light" ? "light" : "dark";
}

export function setTheme(theme: Theme): void {
	document.documentElement.dataset.theme = theme;
	document
		.querySelector('meta[name="theme-color"]')
		?.setAttribute("content", theme === "light" ? "#F2F2EE" : "#14161A");
	writeLocal("theme", theme);
}

export function initTheme(): void {
	setTheme(readLocal<Theme>("theme", "dark"));
}
